import { escapeRegExp } from "lodash-es";

export const INVALID_EMAIL_DOMAIN_ERROR =
  "Signup with your email domain is not allowed. Please use your business/work email or sign in to your existing P0 organization.";

export const getEmailDomain = (email: string): string | undefined => {
  const parts = email.split("@");

  // TODO: use real email parsing and validation library
  if (parts.length > 1 && /.+[.].+/.test(parts[1])) {
    return parts[1];
  }
};

/** Returns a regex pattern that matches email addresses at exactly `domain`. */
export const toOpenIdDomainPattern = (domain: string): string =>
  `^[^@]+@${escapeRegExp(domain)}$`;

export const blockedDomains = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "icloud.com",
  "hotmail.com",
  "outlook.com",
  "msn.com",
  "onmicrosoft.com",
  "aol.com",
  "facebook.com",
  "mitico.org",
  // blocked sign ups due to already existing P0 organization
  "resolve.ai",
  // blocked sign ups from competitors
  "segura.security",
];

export const isValidEmailDomain = (email: string) => {
  const domain = getEmailDomain(email);
  return !!domain && !blockedDomains.includes(domain);
};
